/**
 * Content Discovery Service
 */

import { httpClient } from '../http-client';
import type { RandomHighlightsResponse } from './types';

const API_BASE_URL = '/api/v1';

export const ContentDiscoveryService = {
  /**
   */
  async getRandomHighlights(limit: number = 10): Promise<RandomHighlightsResponse> {
    try {
      const url = `${API_BASE_URL}/content-discovery/random-highlights`;
      const response = await httpClient.get<RandomHighlightsResponse>(url, { params: { limit } });
      return response.data;
    } catch (error) {
      console.error('Error fetching random highlights:', error);
      throw error;
    }
  },
};
